export default {
    namespaced: true,
    state: {
        isBokingNoPlanificados: false,
        isBookingDeclarados: false,
        isBookingsSolicitados: false,
        isBookingsConfirmados: false,
        isSolicitudModificacion: false,
        isBookingsEmbarcados: false,
        isBookingsCancelados: false,
        isVerDeclaradosCancelados: false,
        isLateArrivals: false
    },
    mutations: {
      setIsBokingNoPlanificados(state, payload) {
        state.isBokingNoPlanificados = payload;
      },
      setIsBookingDeclarados(state, payload) {
        state.isBookingDeclarados = payload;
      },
      setIsBookingsSolicitados(state, payload) {
        state.isBookingsSolicitados = payload;
      },
      setIsBookingsConfirmados(state, payload) {
        state.isBookingsConfirmados = payload;
      },
      setIsSolicitudModificacion(state, payload) {
        state.isSolicitudModificacion = payload;
      },
      setIsBookingsEmbarcados(state, payload) {
        state.isBookingsEmbarcados = payload;
      },
      setIsBookingsCancelados(state, payload) {
        state.isBookingsCancelados = payload;
      },
      setIsVerDeclaradosCancelados(state, payload) {
        state.isVerDeclaradosCancelados = payload;
      },
      setIsLateArrivals(state, payload) {
        state.isLateArrivals = payload;
      },
  
    },
    actions: {
      AccionCambiarIsBokingNoPlanificados({ commit }, data) {
        commit("setIsBokingNoPlanificados", data);
      },

      AccionCambiarIsBookingDeclarados({ commit }, data) {
        commit("setIsBookingDeclarados", data);
      },

      AccionCambiarIsBookingsSolicitados({ commit }, data) {
        commit("setIsBookingsSolicitados", data);
      },

      AccionCambiarIsBookingsConfirmados({ commit }, data) {
        commit("setIsBookingsConfirmados", data);
      },

      AccionCambiarIsSolicitudModificacion({ commit }, data) {
        commit("setIsSolicitudModificacion", data);
      },
    
      AccionCambiarIsBookingsEmbarcados({ commit }, data) {
        commit("setIsBookingsEmbarcados", data);
      },

      AccionCambiarIsBookingsCancelados({ commit }, data) {
        commit("setIsBookingsCancelados", data);
      },

      AccionCambiarIsVerDeclaradosCancelado({ commit }, data) {
        commit("setIsVerDeclaradosCancelados", data);
      },

      AccionCambiarIsLateArrivals({ commit }, data) {
        commit("setIsLateArrivals", data);
      },
    
    },
};